import React from 'react';

import type { Tag as ITag } from '../../../../../core/data-sources/frapi/data-types.js';

import { makeTagTitle } from '../helpers.js';

type TagProps = {
  tag: ITag;
  noBorder?: boolean;
  regular?: boolean;
};

const Tag: React.FC<TagProps> = ({ tag, noBorder, regular }) => {
  const classNames = [
    regular ? 'regular' : '',
    noBorder ? 'text-tag' : 'regular-tag',
  ].join(' ');

  return (
    <a href={`/tag/${tag.slug}`} className={classNames}>
      {makeTagTitle(tag.title)}
    </a>
  );
};

export default Tag;
